import { useLayoutEffect } from 'react';
import { APP_BRAND, formatDocumentTitle } from '../utils/documentTitle';

let staticTitle = 'Meisterpfad';
let dynamicTitle: string | null = null;

export function setStaticDocumentTitle(title: string): void {
  staticTitle = title.trim();
  applyDocumentTitle();
}

export function applyDocumentTitle(): void {
  const primary = dynamicTitle?.trim() || staticTitle || null;
  document.title = primary ? formatDocumentTitle(primary) : APP_BRAND;
}

/** Override the route-based tab title while this component is mounted. */
export function useDocumentTitle(title: string | null | undefined): void {
  const normalized = typeof title === 'string' && title.trim() ? title.trim() : null;

  useLayoutEffect(() => {
    dynamicTitle = normalized;
    applyDocumentTitle();
    return () => {
      dynamicTitle = null;
      applyDocumentTitle();
    };
  }, [normalized]);
}
